module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-fill"
  }, [_c('div', {
    staticClass: "container py-3"
  }, [_c('div', {
    staticClass: "row justify-content-center h-100"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "d-flex flex-column w-100 h-100"
  }, [_c('div', {
    staticClass: "flex-grow-1"
  }, [_vm._m(0), _vm._v(" "), (_vm.reservation) ? _c('tab-billing-details', {
    attrs: {
      "reservation": _vm.reservation,
      "readOnly": _vm.isReservationReadOnly && _vm.reservation.status != -5 || _vm.getIsSavingReservation,
      "showInvoiceBtn": false
    }
  }) : _vm._e()], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "mb-2 bold fs-normal d-flex justify-content-between"
  }, [_c('span', [_vm._v("Billing Details")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-4d9c430e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d9c430e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEditV2/TabBilling/TabBilling.vue
// module id = 1944
// module chunks = 0